import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { HeaderConfig, ManageEntitiesContentLayout } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { User } from '../../../classes/entities/User/userTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { useEmptyCreateEntityButtonConfig } from '../../../hooks/useEmptyCreateEntityButtonConfig';
import { CreateUserDialog } from '../../user/CreateUserDialog/CreateUserDialog';
import { UserList } from '../../user/UserList/UserList';
export type UserAdminPageProps = PropsWithoutChildren<Record<never, never>>;
export const UserAdminPage: FunctionComponent<UserAdminPageProps> = React.memo(props => {
  const $ = _c(20);
  prepareProps({
    props,
    ignoreChildren: true
  });
  useConfigureBreadcrumbsWithBuilder(_temp);
  const {
    t
  } = useTranslation();
  const users = useEntities(EntityName.User, "getAll");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      closeOnBackDropClick: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    open: openCreateUserDialog,
    close: closeCreateUserDialog,
    modalProps: createUserModalProps
  } = useModalOpened(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("components.page.UserAdminPage.createEntity");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== openCreateUserDialog || $[4] !== t1) {
    t2 = {
      onCreateEntity: openCreateUserDialog,
      text: t1
    };
    $[3] = openCreateUserDialog;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const createEntityButtonConfig = useEmptyCreateEntityButtonConfig(t2);
  let t3;
  if ($[6] !== t) {
    t3 = t("components.page.UserAdminPage.pageTitle");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      iconConfig: iconConfigurations.prefixed.page.UserAdminPage.titleIcon,
      title: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const headerConfig = t4;
  const renderEntities = _temp2;
  let t5;
  if ($[10] !== createEntityButtonConfig || $[11] !== headerConfig || $[12] !== users) {
    t5 = <ManageEntitiesContentLayout createEntityButtonConfig={createEntityButtonConfig} headerConfig={headerConfig} entities={users} renderEntities={renderEntities} />;
    $[10] = createEntityButtonConfig;
    $[11] = headerConfig;
    $[12] = users;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== closeCreateUserDialog || $[15] !== createUserModalProps) {
    t6 = <CreateUserDialog {...createUserModalProps} onCancel={closeCreateUserDialog} onUserCreated={closeCreateUserDialog} />;
    $[14] = closeCreateUserDialog;
    $[15] = createUserModalProps;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
});
function _temp(builder) {
  return builder.addHomePage().addUserAdminPage();
}
function _temp2(currentPageUsers) {
  return <UserList users={currentPageUsers} />;
}